import React, { useState, useEffect, useRef } from "react";
// componentes
import {
  Button,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Select from "react-select";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
import ColorPicker from "../../../components/ColorPicker/ColorPicker";
import TextEditor from "../../../components/TextEditor";
// redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// services
import { createSpeaker } from "../../../utils/services/speaker";
import { getSchedule } from "../../../utils/services/schedule";
import { getUrlFiles } from "../../../utils/services/files";

function ModalNewSpeaker(props) {
  const { isOpen, toggle } = props;

  //state de loading
  const [isLoading, setIsLoading] = useState(false);
  //state de modais e alertas
  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [successDlg, setSuccessDlg] = useState(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState("");
  //state de erros
  const [erroForm, setErroForm] = useState({});
  //state de dados do formulário
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [category, setCategory] = useState("");
  const [photo, setPhoto] = useState(null);
  const [about, setAbout] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [site, setSite] = useState("");
  const [color, setColor] = useState("");
  const [order, setOrder] = useState(null);
  //state de agendas
  const [agendas, setAgendas] = useState([]);
  const [agendasMulti, setAgendasMulti] = useState([]);
  const [allAgendas, setAllAgendas] = useState(false);

  const refAboutContent = useRef(null);

  // alterna o backdrop do modal
  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }

  // envia a foto do palestrante, se houver, e retorna a url
  async function getImage() {
    if (!photo || !photo.type.startsWith("image/")) {
      return null;
    }

    const data = new FormData();
    data.append("files", photo);
    data.append("folder", "palestrantes");
    data.append("eventId", props.idEvent);

    const response = await getUrlFiles(
      data,
      props.state.global_user_data.data.token,
    );

    return response?.[0]?.url ?? null;
  }

  // valida os campos obrigatórios antes de enviar o formulário
  function verifyErros() {
    if (!name) {
      setErroForm({ name: "O campo Nome é obrigatório" });
      return;
    } else setErroForm({});

    submitForm();
  }

  // monta o payload e cria o palestrante
  async function submitForm() {
    setIsLoading(true);
    try {
      const image = await getImage();

      const agendaArray = [];
      if (allAgendas) {
        agendas.forEach((e) => agendaArray.push(e.id));
      } else {
        agendasMulti.forEach((e) => agendaArray.push(e.value));
      }

      const data = {
        eventId: props.idEvent,
        name,
        position,
        category,
        photo: image,
        about: refAboutContent.current.getContent(),
        facebook,
        instagram,
        linkedin,
        whatsapp,
        site,
        color,
        order,
        agendas: agendaArray,
      };

      const res = await createSpeaker(data);
      if (res.message === "created") {
        setSuccessDlg(true);
      } else {
        setSubmitErrorMessage("Erro ao criar palestrante.");
      }
    } catch (error) {
      console.error("Erro ao criar palestrante:", error);
      setSubmitErrorMessage("Erro ao criar palestrante.");
    } finally {
      setIsLoading(false);
    }
  }

  // busca as agendas do evento para popular o select
  async function getAgendas() {
    const res = await getSchedule({
      jwt: props.state.global_user_data.data.token,
      id: props.idEvent,
      offset: 1,
      limit: 9999,
      search: "",
    });

    if (res?.agenda?.data) {
      setAgendas(res.agenda.data);
    } else {
      toast.error("Erro ao buscar agendas.");
    }
  }

  useEffect(() => {
    getAgendas();
  }, []);

  // trata a seleção de "todos" no select de agendas
  function handleAgendaMulti(a) {
    const selected = a.filter((e) => e.value === "todos");
    if (selected.length > 0) {
      a = selected;
      setAllAgendas(true);
    } else {
      setAllAgendas(false);
    }
    setAgendasMulti(a);
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={() => {
          toggleBackdrop();
        }}
        autoFocus={true}
        centered={true}
      >
        {successDlg ? (
          <SweetAlert
            success
            title={"Criado"}
            onConfirm={() => {
              setSuccessDlg(false);
              toggle();
            }}
          >
            {"Palestrante criado com sucesso!"}
          </SweetAlert>
        ) : null}
        {submitErrorMessage && (
          <SweetAlert
            danger
            title="Erro"
            onConfirm={() => setSubmitErrorMessage("")}
          >
            {submitErrorMessage}
          </SweetAlert>
        )}
        <ModalHeader toggle={toggle}>Novo Palestrante</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <div>
                <label className="form-label">Nome*</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setName(e.target.value)}
                />
                {erroForm.name && (
                  <span className="text-danger">{erroForm.name}</span>
                )}
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Foto</label>
                <Input
                  className="form-control"
                  type="file"
                  id="formFile"
                  onChange={(e) => setPhoto(e.target.files?.[0])}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col md={12}>
              <label className="form-label">Sobre</label>
              <TextEditor refState={refAboutContent} defaultState={about} />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Empresa / Cargo / Especialidade
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setPosition(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Facebook
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setFacebook(e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Instagram
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setInstagram(e.target.value)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  LinkedIn
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setLinkedin(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  WhatsApp
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setWhatsapp(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Site
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setSite(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Categoria
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setCategory(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <ColorPicker
                classOfContainer="bg-edit-shedule-event-pickr"
                labelText="Cor"
                setStateFunc={setColor}
              />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div>
                <label className="form-label" style={{ marginTop: "10px" }}>
                  Ordem
                </label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setOrder(e.target.value)}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginBottom: 10, marginTop: "10px" }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Agendas</label>
                <Select
                  value={agendasMulti}
                  placeholder={"Selecione"}
                  isMulti={true}
                  onChange={(e) => {
                    handleAgendaMulti(e);
                  }}
                  noOptionsMessage={() => "Nenhuma opção encontrada"}
                  options={[
                    {
                      options:
                        agendas?.length > 0 && !allAgendas
                          ? [
                              { label: "TODOS", value: "todos" },
                              ...agendas?.map((e) => {
                                return { label: e.title, value: e.id };
                              }),
                            ]
                          : [],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80, marginRight: 10 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>

            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              onClick={verifyErros}
            />
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(ModalNewSpeaker);
